import Vue from 'vue'
import './filters'
import './directives.js'
import vuetify from './plugins/vuetify'
import './plugins/meta'
import App from './App.vue'
import router from './router'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import './plugins/mdi';
import Axios from 'axios';
import PreferenceStore from '@/store/PreferenceStore';
import './styles/myext.scss';
import AsyncComputed from 'vue-async-computed';
import './assets/styles/styles.scss';

Vue.config.productionTip = false
Vue.use(AsyncComputed);

Axios.defaults.withCredentials = true;

PreferenceStore.LOAD_PREFERENCES();


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
